<template>
    <!-- 图片题 -->
    <div class="paper-item">
        <div class="detail">
            <!-- 题干 -->
            <div class="topic-title">
                <i v-if="singleTopic.key" class="key-topic nucfont inuc-favor-fill"></i>
                <p class="no">{{ $parent.number }}.</p>
                <p class="titleRT" v-html="singleTopic.topic.titleRT"></p>
                <span class="operate-reset" title="重置图片位置" @click="resetZoom"><i class="nucfont inuc-reset"></i></span>
            </div>

            <!-- 图片区域 -->
            <div class="graphic-topic">
                <!-- 考试 -->
                <div class="graphic-topic-wrap graphic-topic-exam" v-if="isExam" ref="bigImage">
                    <img class="exam-img"
                         :src="singleTopic.topic.picSrcUrl" alt="题目">

                    <!-- 标框区域 -->
                    <div v-if="isMarkTopic" class="mark-list" @click.self="addMark">
                        <div class="mark-item" v-for="(item, index) in currentAnswer.tags"
                             @click="delMark(index)"
                             :key="index"
                             :style="{left: item.x*currentImgWidth-radius+'px', top:item.y*currentImgHeight-radius+'px'}">
                            <div class="mark-label">
                                <span class="label-name" v-if="item.tagName">{{item.tagName}}</span>
                                <i v-else class="nucfont inuc-close"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 回查 -->
                <el-carousel class="graphic-topic-wrap graphic-topic-view" v-else
                             direction="vertical" :autoplay="false" ref="graphicCarousel">
                    <el-carousel-item class="graphic-img-wrap" label="题目">
                        <img class="graphic-img" :src="singleTopic.topic.picSrcUrl" alt="题目">
                        <!-- 标框区域 -->
                        <div v-if="isMarkTopic" class="mark-list">
                            <div class="mark-item" v-for="(item, index) in currentAnswer.answer.tags"
                                 :key="index"
                                 :style="{left: item.x*currentImgWidth-radius+'px', top:item.y*currentImgHeight-radius+'px'}">
                                <div class="mark-label" v-if="item.tagName">
                                    <span class="label-name">{{item.tagName}}</span>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                    <el-carousel-item class="graphic-img-wrap" label="答案">
                        <img class="graphic-img" :src="singleTopic.topic.picViewUrl" alt="答案">
                        <!-- 标框区域 -->
                        <div v-if="isMarkTopic" class="mark-list">
                            <div class="mark-item" v-for="(item, index) in currentAnswer.answer.tags"
                                 :key="index"
                                 :style="{left: item.x*currentImgWidth-radius+'px', top:item.y*currentImgHeight-radius+'px'}">
                                <div class="mark-label" v-if="item.tagName">
                                    <span class="label-name">{{item.tagName}}</span>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>

        <!-- 作答区域 -->
        <div class="operate-area" v-if="isExam">
            <div class="operate-btn-group">
                <el-button @click="onChoose(true)" :class="{'active': currentAnswer.isPass===true}"
                           class="btn-safe" type="success" plain>安全</el-button>
                <el-button @click="onChoose(false)" :class="{'active': currentAnswer.isPass===false}"
                           class="btn-danger" type="danger" plain>嫌疑</el-button>
            </div>
        </div>

        <div class="others" v-else>
            <div class="answer-result" v-if="!isPreview">
                <el-tag v-if="currentAnswer.result" type="success">正确</el-tag>
                <el-tag v-else type="danger">错误</el-tag>
            </div>

            <div class="answer-area">
                <ul class="answer">
                    <li>
                        <span class="tag">{{ $t('paper.answer') }}：</span>
                        {{singleTopic.topic.isSafe ? '安全' : '嫌疑'}}
                    </li>
                    <li v-if="!isPreview" :class="{'wrong': !currentAnswer.result}">
                        <span class="tag">学员作答：</span>
                        {{safeReplyText}}
                    </li>
                    <li v-if="isMarkWrong" class="wrong">
                        危险品位置标记错误
                    </li>
                </ul>
                <p class="analysis" v-html="
                                    '<span class=tag>' + $t('paper.analysis') + '：</span>' + (singleTopic.topic.analysisRT||$t('c.none')) "
                ></p>
            </div>
        </div>

        <el-dialog
            custom-class="kp-selector"
            title="选择违禁品知识点"
            :visible.sync="kpSelector"
            top="10vh"
            width="800px"
            :close-on-click-modal="true"
            :append-to-body="false"
            :modal-append-to-body="false"
        >
            <div class="knowledge-selector">
                <div class="danger-category" v-for="item in markKnowledgeMenu" :key="item.id">
                    <h5>{{ item.value }}</h5>
                    <div class="danger-items">
                        <el-tag
                            v-for="v in item.children"
                            :key="v.id"
                            @click="currentTagKp = {id: v.id, name: v.value}"
                            :effect="currentTagKp.id === v.id ? 'dark': ''"
                            size="medium"
                        >
                            {{ v.value }}
                        </el-tag>
                    </div>
                </div>

                <div class="btn-footer">
                    <el-button type="warning" @click="submitTagKp" size="medium">确定</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import panzoom from 'panzoom'

export default {
    components: {},

    props: {
        // 是考试还是回查（预览）
        isExam: {
            type: Boolean,
            default: false
        },
        response: {}
    },

    data() {
        return {
            currentImgWidth: 0,
            currentImgHeight: 0,
            isPreview: false,  // 是否为组卷预览
            radius: 14,
            kpSelector: false,
            currentTagKp: {id: 0, name: ''},
            panning: false,
        }
    },

    computed: {
        ...mapGetters([
            'markKnowledgeMenu',
        ]),
        // 当前题目
        singleTopic() {
            this.resetZoom()
            return this.$parent.singleTopic
        },
        isMarkTopic() {
            return this.singleTopic.topic.type === 6 || this.singleTopic.topic.type === 7
        },

        /**
         *   当前题目的作答数据
         *   考试：代表answer字段里的数据，包含isPass、tags
         *   回查：包含answer、result、topicID
         */
        currentAnswer() {
            // 考试
            if (this.isExam) {
                return this.response[this.singleTopic.topicID]
            }

            // 回查
            if (this.response) {
                return this.response.find(v => v.topicID === this.singleTopic.topicID);
            }

            // 预览(返回一个默认值防止报错)
            this.isPreview = true
            return {
                answer: {
                    isPass: null,
                    tags: [],
                },
                result: null,
            }
        },

        /**
         * 是否为危险品标记错误
         */
        isMarkWrong() {
            // 标记题 & 答案危险 & 作答危险 & 答错了
            return this.isMarkTopic &&
                !this.singleTopic.topic.isSafe &&
                this.currentAnswer.answer.isPass === false &&
                !this.currentAnswer.result;
        },

        safeReplyText() {
            if (this.currentAnswer.answer.isPass !== null) {
                return this.currentAnswer.answer.isPass ? '安全': '嫌疑'
            } else {
                return '未作答'
            }
        }
    },

    mounted() {
        this.initKeyboard()

        if (this.isExam) {
            this.initZoom()
        }

        $(window).on('resize', e => {
            this.$nextTick(() => {
                this.adjustImage()
            })
        })

        this.$store.dispatch('getMarkKnowledgeMenu')
    },

    beforeDestroy() {
        $(document).off('keydown.graphic')
        $(window).off('resize')
    },

    watch: {
        "$parent.number": {
            handler(v) {
                this.$nextTick(() => {
                    this.adjustImage()
                })
            },
            immediate: true
        },
    },

    methods: {
        // 选择了安全还是嫌疑
        onChoose(_isPass) {
            let topic = this.singleTopic.topic

            this.response[topic.id].isPass = _isPass
            this.$parent.savePaperOnLocal()

            // 点安全去掉所有框
            if (_isPass) {
                this.response[topic.id].tags = []
            }
        },

        // 计算图片的自适应宽高，每次切题时都需调用
        adjustImage() {
            console.log('adjust!')
            let current = this.singleTopic.topic
            let $container = $('.graphic-topic-wrap')
            let W1 = $container.width()
            let H1 = $container.height()
            let W2 = current.width
            let H2 = current.height
            let zoom = Math.max(W2 / W1, H2 / H1)
            let resultW = Math.ceil(W2 / zoom)
            let resultH = Math.ceil(H2 / zoom)
            this.currentImgWidth = resultW
            this.currentImgHeight = resultH

            let style = {
                width: resultW,
                height: resultH
            }

            $('.exam-img').css(style)
            $('.graphic-img').css(style)
            $('.mark-list').css(style)
        },

        // 添加标框
        addMark(e) {
            if (this.panning) return

            if (this.response[this.singleTopic.topicID].tags.length >= 30) {
                return this.$message.error('标框达到上限！')
            }

            let $img = $(e.target)
            let w = $img.width()
            let h = $img.height()
            /**
             * 我们认定，将点击的位置设为圆心，传给后端直接就用这个位置
             * 但是渲染的时候，因为框是从左上角渲染的，想要渲染的点和圆心重合，就得减去半径
             */
            let x = (e.offsetX / w).toFixed(2) - 0  // 框圆心距图片左边的比例（小数）
            let y = (e.offsetY / h).toFixed(2) - 0    // 框圆心距图片上边的比例（小数）

            if (this.singleTopic.topic.type === 7) {
                this.kpSelector = true
                this.currentTagKp = {id: 0, name: ''}
                this.currentX = x
                this.currentY = y
            } else {
                this.response[this.singleTopic.topicID].tags.push({x, y})
                this.$parent.savePaperOnLocal()
                // 画框则自动选择嫌疑
                this.response[this.singleTopic.topicID].isPass = false
            }

        },
        // 删除标框
        delMark(index) {
            if (this.panning) return

            this.response[this.singleTopic.topicID].tags.splice(index, 1)
            this.$parent.savePaperOnLocal()

            // 去掉所有框则自动选择安全
            if (!this.response[this.singleTopic.topicID].tags.length) {
                this.response[this.singleTopic.topicID].isPass = true
            }
        },
        submitTagKp() {
            const {id, name} = this.currentTagKp
            if (!id) {
                return this.kpSelector = false
            }

            const tag = {
                x: this.currentX,
                y: this.currentY,
                tagKp: id,
                tagName: name
            }

            this.response[this.singleTopic.topicID].tags.push(tag)
            this.$parent.savePaperOnLocal()
            // 画框则自动选择嫌疑
            this.response[this.singleTopic.topicID].isPass = false

            this.kpSelector = false
        },

        initZoom() {
            this.$nextTick(() => {
                const options = {
                    zoomSpeed: 0.065,
                    maxZoom: 4,
                    minZoom: 1,
                    smoothScroll: false,
                    transformOrigin: {x: 0.5, y: 0.5}, // 缩放中心点
                    zoomDoubleClickSpeed: 1, // 禁止双击放大
                    // 取消键盘事件
                    filterKey: function (/* e, dx, dy, dz */) {
                        return true
                    }
                }

                this.panRate = 0

                this.zoom = panzoom(this.$refs.bigImage, options)

                this.zoom.on('pan', (e) => {
                    this.panRate++

                    // 忽略掉过小的移动幅度
                    if (this.panRate > 5) {
                        this.panning = true
                    }
                })

                this.zoom.on('panend', (e) => {
                    this.panRate = 0

                    setTimeout(() => {
                        this.panning = false
                        console.log(this.panning)
                    }, 0)
                })
            })
        },
        resetZoom() {
            if (this.zoom) {
                this.zoom.moveTo(0, 0)
                this.zoom.zoomAbs(0, 0, 1)
                this.panning = false
            }
        },

        initKeyboard() {
            $(document).on('keydown.graphic', e => {
                let key = e.keyCode
                if (this.multiMode || this.isExam) return
                // 上
                if (key === 38) {
                    this.$refs.graphicCarousel.prev()
                }
                // 下
                if (key === 40) {
                    this.$refs.graphicCarousel.next()
                }
            })
        }
    },
}
</script>

<style lang="scss">
@import '~@/style/const';

$mark-size: 28px;

// 图片题
.m-paperGraphic {
    .paper-container {
        flex: 1;
    }

    .paper-main {
        height: 100%;
    }

    .paper-left {
        display: flex;
        flex-direction: column;
        height: 100%;
        margin-bottom: 0!important;
    }

    .paper-list-container {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .paper-list {
        flex: 1;
        margin: 0 0 15px 0 !important;
    }

    .paper-item {
        height: calc(100% - 35px);
        padding-top: 12px!important;
        display: flex;
        flex-direction: column;

        .detail {
            display: flex;
            flex-direction: column;
            flex: 1;
            padding-right: 0!important;
        }

        .topic-title {
            padding: 5px 0 10px 0;
            margin-bottom: 0!important;
        }
    }

    .graphic-topic {
        flex: 1;
        padding-bottom: 20px;
        overflow: hidden;
    }

    .mark-list {
        position: absolute;
        //border: 1px solid #ccc;
        cursor: url(~@/assets/images/icon/icon1.png) 16 16, auto;
        //cursor: auto;
        .mark-item {
            position: absolute;
            width: $mark-size;
            height: $mark-size;
            border: 3px solid $red;
            border-radius: 50%;
            box-shadow: 0 0 0 1px #fff, 0 0 0 1px #fff inset, 1px 4px 10px 0 rgba(0,0,0,.1);
            cursor: pointer;
            &:hover {
                .nucfont {
                    color: #fff;
                    transform: scale(1.1);
                }
            }
            &:before {
                content: '';
                position: absolute;
                left: 50%;
                top: 50%;
                width: 5px;
                height: 5px;
                transform: translate(-50%, -50%);
                border-radius: 50%;
                background-color: $red;
            }
        }
        .mark-label {
            position: absolute;
            left: 100%;
            margin-left: 13px;
            margin-top: -3px;
            height: 28px;
            line-height: 25px;
            padding: 0 12px;
            border: 2px solid #fff;
            border-radius: 20px;
            background-color: rgba(0,0,0,.7);
            &:hover {
                .nucfont {
                    color: #fff;
                    transform: scale(1.1);
                }
            }
            &:before {
                content: ' ';
                position: absolute;
                right: 100%;
                top: 50%;
                width: 12px;
                height: 2px;
                background-color: #fff;
            }
            .nucfont {
                display: inline-block;
                color: #ccc;
                font-size: 12px;
                vertical-align: 2px;
            }

            .label-name {
                font-size: 12px;
                color: #fff;
                white-space: nowrap;
                vertical-align: 2px;
            }
        }
    }

    .graphic-topic-exam {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .exam-img {
            width: 0;
            height: 0;
        }
    }

    .graphic-topic-view {
        position: relative;
        &,
        .el-carousel,
        .el-carousel__container {
            height: 100%;
        }

        .el-carousel__indicators--labels {
            left: 90%;
        }

        .el-carousel__indicator {
            display: flex;
            flex-direction: row-reverse;

            .el-carousel__button {
                width: auto;
                height: auto;
                padding: 3px 10px;
            }
        }

        .graphic-img-wrap {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .graphic-img {
            width: 0;
            height: 0;
        }

        .mark-list {
            cursor: auto;
            .mark-item {
                cursor: auto;
            }
        }
    }

    .operate-area {
        padding-top: 10px;
        border-top: dashed 1px #d8d8d8;
        .operate-btn-group {
            text-align: center;
        }
        .btn-safe.active {
            background: #5daf34;
            border-color: #5daf34;
            color: #fff;
        }
        .btn-danger.active {
            background: #dd6161;
            border-color: #dd6161;
            color: #fff;
        }
    }

    .others {
        display: flex;
        padding-top: 5px;
        border-top: dashed 1px #d8d8d8;

        .answer-result {
            display: flex;
            align-items: center;
            padding-right: 20px;
        }

        .answer-area {
            flex: 1;
            border: none !important;

            .answer {
                display: flex;
            }

            li {
                margin-right: 40px;
            }

            .wrong {
                color: $red;
                .tag {
                    color: $red;
                }
            }
        }
    }

    .button-group {
        margin-top: 0 !important;
        padding-bottom: 20px;
    }

    .operate-reset {
        padding: 10px 15px;
        text-align: center;
        cursor: pointer;
        i {
            font-size: 20px;
            color: #666;
        }
    }

    .kp-selector {

        .knowledge-selector {
            border-radius: 4px;
            .el-dialog__footer {
                padding-bottom: 15px;
            }
        }

        .danger-category {
            h5 {
                margin: 10px 0 0 5px;
                font-size: 14px;
                color: #7a7a7a;
                font-weight: 600;
            }

            .danger-items {
                padding: 5px 0 10px 15px;
            }

            .el-tag {
                margin-top: 10px;
                margin-right: 8px;
                cursor: pointer;
            }
        }

        .btn-footer {
            padding: 0 10px 10px 0;
            text-align: right;
        }
    }
}
</style>
